import { KProperty02ce7r476m8633 as KProperty0 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  Companion_getInstance3h03aipe2gus4 as Companion_getInstance,
  LocalDate31mqn6zavbpi8 as LocalDate,
} from './LocalDate.mjs';
import {
  Companion_getInstance3qlladteis94 as Companion_getInstance_0,
  LocalTime22kisvxz6f9p4 as LocalTime,
  get_ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS1pgdef0x3xl4f as get_ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS,
} from './LocalTime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LocalDateTimeSerializer_getInstance30joe8yzqyv05 as LocalDateTimeSerializer_getInstance } from './serializers/LocalDateTimeSerializers.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  get_ISO_DATETIME2pryl9hy3c2kg as get_ISO_DATETIME,
  Companion_instance7gy4c97td3qb as Companion_instance,
} from './format/LocalDateTimeFormat.mjs';
import { createThis2j2avj17cvnv2 as createThis } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  multiply2k9eolhnz1bjv as multiply,
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
  numberToLong2pakxeg38estk as numberToLong,
  dividelr0uqtdj497z as divide,
  modulooi4g1kq3dmtt as modulo,
  negate13xrbakfwasjy as negate,
  shiftRight2gqph14wydb8s as shiftRight,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { get_ONEazvfdh9ju3d4 as get_ONE } from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/boxedLong/boxedLong.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_ISO_DATE1ah0stqy13618 as get_ISO_DATE } from './format/LocalDateFormat.mjs';
import {
  alternativeParsing1gmwubnsvpp9b as alternativeParsing,
  char1r4ssccmdfesy as char,
} from './format/DateTimeFormatBuilder.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function getIsoDateTimeFormat() {
  return Formats_getInstance().ISO_1;
}
function format(_this__u8e3s4, format) {
  return format.format_l1mq08_k$(_this__u8e3s4);
}
function get_ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS() {
  _init_properties_LocalDateTime_kt__bewbbg();
  var tmp0 = ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate;
  var tmp = KProperty0();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS', 0, tmp, _get_ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS_$ref_4ujexv(), null);
  return tmp0.get_value_j01efc_k$();
}
var ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.MIN_1 = LocalDateTime().new_kotlinx_datetime_LocalDateTime_zaqrue_k$(Companion_getInstance().MIN_1, Companion_getInstance_0().MIN_1);
        this.MAX_1 = LocalDateTime().new_kotlinx_datetime_LocalDateTime_zaqrue_k$(Companion_getInstance().MAX_1, Companion_getInstance_0().MAX_1);
      }
      parse_bq7xns_k$(input, format) {
        return format.parse_xovy9i_k$(input);
      }
      parse$default_rpbnp3_k$(input, format, $super) {
        format = format === VOID ? getIsoDateTimeFormat() : format;
        return $super === VOID ? this.parse_bq7xns_k$(input, format) : $super.parse_bq7xns_k$.call(this, input, format);
      }
      serializer_9w0wvi_k$() {
        return LocalDateTimeSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_1() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
var FormatsClass;
function Formats() {
  if (FormatsClass === VOID) {
    class $ {
      constructor() {
        Formats_instance = this;
        this.ISO_1 = get_ISO_DATETIME();
      }
    }
    initMetadataForObject($, 'Formats');
    FormatsClass = $;
  }
  return FormatsClass;
}
var Formats_instance;
function Formats_getInstance() {
  if (Formats_instance === VOID)
    new (Formats())();
  return Formats_instance;
}
var LocalDateTimeClass;
function LocalDateTime() {
  if (LocalDateTimeClass === VOID) {
    class $ {
      constructor(date, time) {
        return new.target.new_kotlinx_datetime_LocalDateTime_zaqrue_k$(date, time);
      }
      static new_kotlinx_datetime_LocalDateTime_zaqrue_k$(date, time) {
        Companion_getInstance_1();
        var $this = createThis(this);
        $this.date_1 = date;
        $this.time_1 = time;
        return $this;
      }
      static new_kotlinx_datetime_LocalDateTime_d9xan1_k$(year, month, day, hour, minute, second, nanosecond) {
        Companion_getInstance_1();
        second = second === VOID ? 0 : second;
        nanosecond = nanosecond === VOID ? 0 : nanosecond;
        return this.new_kotlinx_datetime_LocalDateTime_zaqrue_k$(LocalDate().new_kotlinx_datetime_LocalDate_81790c_k$(year, month, day), LocalTime().new_kotlinx_datetime_LocalTime_huq53_k$(hour, minute, second, nanosecond));
      }
      static new_kotlinx_datetime_LocalDateTime_rd905s_k$(year, month, day, hour, minute, second, nanosecond) {
        Companion_getInstance_1();
        second = second === VOID ? 0 : second;
        nanosecond = nanosecond === VOID ? 0 : nanosecond;
        return this.new_kotlinx_datetime_LocalDateTime_zaqrue_k$(LocalDate().new_kotlinx_datetime_LocalDate_rqj1zf_k$(year, month, day), LocalTime().new_kotlinx_datetime_LocalTime_huq53_k$(hour, minute, second, nanosecond));
      }
      get_year_woy26e_k$() {
        return this.date_1.year_1;
      }
      get_nanosecond_fws9td_k$() {
        return this.time_1.nanosecond_1;
      }
      compareTo_c32ujr_k$(other) {
        var d = this.date_1.compareTo_e7gwgq_k$(other.date_1);
        if (!(d === 0)) {
          return d;
        }
        return this.time_1.compareTo_6io3dl_k$(other.time_1);
      }
      compareTo_hpufkf_k$(other) {
        return this.compareTo_c32ujr_k$(other instanceof LocalDateTime() ? other : THROW_CCE());
      }
      equals(other) {
        var tmp;
        if (this === other) {
          tmp = true;
        } else {
          var tmp_0;
          if (other instanceof LocalDateTime()) {
            tmp_0 = this.compareTo_c32ujr_k$(other) === 0;
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        }
        return tmp;
      }
      hashCode() {
        return this.date_1.hashCode() ^ this.time_1.hashCode();
      }
      toString() {
        return format(this, get_ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS());
      }
      toEpochSecond_e9u42_k$(offset) {
        var epochDay = this.date_1.toEpochDays_tp9eth_k$();
        // Inline function 'kotlin.Long.times' call
        var tmp0 = multiply(epochDay, fromInt(86400));
        // Inline function 'kotlin.Long.plus' call
        var other = this.time_1.toSecondOfDay_a2clsa_k$();
        var secs = add(tmp0, fromInt(other));
        var tmp0_0 = secs;
        // Inline function 'kotlin.Long.minus' call
        var other_0 = offset.totalSeconds_1;
        secs = subtract(tmp0_0, fromInt(other_0));
        return secs;
      }
    }
    initMetadataForClass($, 'LocalDateTime', VOID, VOID, [Comparable()], VOID, VOID, {0: LocalDateTimeSerializer_getInstance});
    LocalDateTimeClass = $;
  }
  return LocalDateTimeClass;
}
function plusSeconds(_this__u8e3s4, seconds) {
  _init_properties_LocalDateTime_kt__bewbbg();
  if (seconds === 0) {
    return _this__u8e3s4;
  }
  var currentNanoOfDay = _this__u8e3s4.time_1.toNanosecondOfDay_dywvsy_k$();
  var totalNanos = add(multiply(numberToLong(seconds % 86400 | 0), 1000000000n), currentNanoOfDay);
  var tmp = seconds / 86400 | 0;
  // Inline function 'kotlin.floorDiv' call
  var other = 86400000000000n;
  var q = divide(totalNanos, other);
  if ((totalNanos ^ other) < 0n && !(multiply(q, other) === totalNanos)) {
    var _unary__edvuaz = q;
    q = subtract(_unary__edvuaz, get_ONE());
  }
  var tmp$ret$0 = q;
  var totalDays = add(numberToLong(tmp), tmp$ret$0);
  // Inline function 'kotlin.mod' call
  var other_0 = 86400000000000n;
  var r = modulo(totalNanos, other_0);
  var newNanoOfDay = add(r, other_0 & shiftRight((r ^ other_0) & (r | negate(r)), 63));
  var newTime = newNanoOfDay === currentNanoOfDay ? _this__u8e3s4.time_1 : Companion_getInstance_0().ofNanoOfDay_q9nllz_k$(newNanoOfDay);
  return LocalDateTime().new_kotlinx_datetime_LocalDateTime_zaqrue_k$(_this__u8e3s4.date_1.plusDays_w89bio_k$(totalDays), newTime);
}
function ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda() {
  _init_properties_LocalDateTime_kt__bewbbg();
  var tmp = Companion_instance;
  return tmp.build_jyqq35_k$(ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda$lambda);
}
function ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda$lambda($this$build) {
  _init_properties_LocalDateTime_kt__bewbbg();
  $this$build.date_aq11yp_k$(get_ISO_DATE());
  var tmp = [ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda$lambda$lambda];
  alternativeParsing($this$build, tmp, ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda$lambda$lambda_0);
  $this$build.time_eev9o3_k$(get_ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS());
  return Unit_instance;
}
function ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda$lambda$lambda($this$alternativeParsing) {
  _init_properties_LocalDateTime_kt__bewbbg();
  char($this$alternativeParsing, _Char___init__impl__6a9atx(116));
  return Unit_instance;
}
function ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda$lambda$lambda_0($this$alternativeParsing) {
  _init_properties_LocalDateTime_kt__bewbbg();
  char($this$alternativeParsing, _Char___init__impl__6a9atx(84));
  return Unit_instance;
}
function _get_ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS_$ref_4ujexv() {
  return constructCallableReference(() => get_ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS(), 0, 0, 70);
}
var properties_initialized_LocalDateTime_kt_aulw4q;
function _init_properties_LocalDateTime_kt__bewbbg() {
  if (!properties_initialized_LocalDateTime_kt_aulw4q) {
    properties_initialized_LocalDateTime_kt_aulw4q = true;
    ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate = lazy(ISO_DATETIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda);
  }
}
//region block: exports
export {
  Companion_getInstance_1 as Companion_getInstance29buwn7hkq75x,
  LocalDateTime as LocalDateTime3vqv9moe7clf4,
  plusSeconds as plusSeconds2y48czw9c0543,
};
//endregion

//# sourceMappingURL=LocalDateTime.mjs.map
